// extracted by mini-css-extract-plugin
module.exports = {"list":"a10a3f92e9--list--gjRn8","item":"a10a3f92e9--item--mXIMa","more":"a10a3f92e9--more--DokTt","close":"a10a3f92e9--close--J8fTr"};